import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2024. FibraLink S.A. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
